import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';
import { SchematicDataOut, SchematicSaveRequest } from '../models/schematic.model';

@Injectable({
  providedIn: 'root',
})
export class SchematicService {
  private pathApi: string;

  constructor(
    private http: HttpClient,
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig,
  ) {
    this.pathApi = this.config.pathApi + 'Schematic/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  save(obj: SchematicSaveRequest) {
    return this.http.post(`${this.pathApi}save`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getBySubstationId(substationId: number) {
    return this.http.get<SchematicDataOut>(`${this.pathApi}getBySubstationId/${substationId}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  publish(substationId: number, image?: string) {
    return this.http.post(`${this.pathApi}publish/${substationId}`, { image }, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
